import { createElement, type CSSProperties, type ComponentType, type ReactNode } from 'react';

export interface IconComponentProps {
  style?: CSSProperties
  spin?: boolean
  className?: string
}

export const antdIcon = (
  Icon: ComponentType<IconComponentProps>,
  props?: IconComponentProps
): ReactNode => createElement(Icon, props);
